import getCurrentDateTime from './get-current-date-time';
import generatePMFSurveyLink from './generate-pmf-survey-link';
import isNPSAvailable from './is-nps-available';
import isPMFAvailable from './is-pmf-available';

export default {
  getCurrentDateTime,
  generatePMFSurveyLink,
  isNPSAvailable,
  isPMFAvailable,
};
